import React, { useState } from "react";
import styles from "./Search.module.sass";
import Icon from "components/Icon";
import cn from "classnames";

const Search = ({
  className,
  value,
  setValue,
  placeholder,
  name,
  type,
  icon,
}) => {
  return (
    <div className={cn(className, styles.form)}>
      <input
        className={styles.input}
        type={type}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        name={name}
        placeholder={placeholder}
        required
      />
      <button className={styles.result}>
        <Icon name={icon} size="24" />
      </button>
    </div>
  );
};
export default Search;
